import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={19}
      fill="none"
      viewBox="0 0 20 19"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 5.252a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1ZM11.25 13.502a1.25 1.25 0 1 1-2.5-.001 1.25 1.25 0 0 1 2.5 0Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 0c-.865 0-1.729.428-2.224 1.284L.348 14.15c-.989 1.712.247 3.852 2.223 3.852H17.43c1.976 0 3.212-2.14 2.223-3.852L12.224 1.284A2.545 2.545 0 0 0 10 0Zm0 2c.149 0 .356.049.492.284L17.92 15.15a.54.54 0 0 1 0 .568.54.54 0 0 1-.491.284H2.57a.54.54 0 0 1-.49-.284.54.54 0 0 1 0-.568L9.507 2.284A.543.543 0 0 1 10 2Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
